(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rebuy-pet-badges"] && !Shopify.designMode) return;
  try {
    (() => {
    const templates = new Map();

    document
      .querySelectorAll('[data-rebuy-pet-badge-template]')
      .forEach((template) => {
        templates.set(
          template.dataset.rebuyPetBadgeTemplate,
          template.content.cloneNode(true)
        );
      });

    const badgeType = (card) => {
      if (card.classList.contains('tag-pet_dog')) return 'dog';
      if (card.classList.contains('tag-pet_cat')) return 'cat';
      if (card.classList.contains('tag-pet_any')) return 'any';
      return null;
    };

    const addBadges = () => {
      document
        .querySelectorAll('.rebuy-bundle-builder .rebuy-product-block')
        .forEach((card) => {
        const media = card.querySelector('.rebuy-product-media');
        const type = badgeType(card);

        if (!media || !type || media.querySelector('.rebuy-pet-badge')) return;

        const template = templates.get(type);

        if (template) media.append(template.cloneNode(true));
      });
    };

    const initialize = () => {
      addBadges();

      let queued = false;
      const observer = new MutationObserver(() => {
        if (queued) return;
        queued = true;

        requestAnimationFrame(() => {
          queued = false;
          addBadges();
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
